import { Button, Group, SimpleGrid, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import type { AppError } from '@flow/core';
import { applyErrors } from '../../ui/forms';
import { reportError } from '../../app/services';

export interface TournamentFormValues {
  name: string;
  startDate: string;
  endDate: string;
}

export const emptyTournamentForm = (): TournamentFormValues => ({ name: '', startDate: '', endDate: '' });

/** New / edit tournament: name and optional dates (they sort the dashboard). The event is chosen per round. */
export const TournamentForm = ({ initial, submitLabel, onSubmit, onCancel }: {
  initial: TournamentFormValues;
  submitLabel: string;
  onSubmit: (v: TournamentFormValues) => Promise<AppError | null>;
  onCancel: () => void;
}) => {
  const form = useForm<TournamentFormValues>({ mode: 'controlled', initialValues: initial });
  const submit = form.onSubmit(async (v) => {
    const e = await onSubmit(v);
    if (e && !applyErrors(form, e)) reportError(e);
  });
  return (
    <form onSubmit={submit} noValidate>
      <Stack>
        <TextInput label="Name" placeholder="e.g. Golden Gate Invitational" required data-autofocus {...form.getInputProps('name')} data-testid="tournament-name" />
        <SimpleGrid cols={2}>
          <TextInput type="date" label="First day" description="Optional" {...form.getInputProps('startDate')} data-testid="tournament-start" />
          <TextInput type="date" label="Last day" description="Blank for one day" min={form.values.startDate || undefined} {...form.getInputProps('endDate')} data-testid="tournament-end" />
        </SimpleGrid>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>Cancel</Button>
          <Button type="submit" variant="filled" data-testid="tournament-save">{submitLabel}</Button>
        </Group>
      </Stack>
    </form>
  );
};
